var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1667 81.6667V1.66667C94.1667 0.666667 93.5 0 92.5 0H17.5C16.5 0 15.8333 0.666667 15.8333 1.66667V25H19.1667V3.33333H90.8333V80H75.8333C74.8333 80 74.1667 80.6667 74.1667 81.6667V96.6667H19.1667V71.6667H15.8333V98.3333C15.8333 99.3333 16.5 100 17.5 100H75.8333C76.3333 100 76.6667 99.8333 77 99.5L93.6667 82.8333C93.8333 82.6667 93.8333 82.5 94 82.3333V82.1667C94.1667 82 94.1667 81.8333 94.1667 81.6667ZM77.5 83.3333H88.5L83 88.8333L77.5 94.3333V83.3333Z",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 63.3333H37.5H44.1667V60H39.1667V28.3333C39.1667 27.3333 38.5 26.6667 37.5 26.6667H27.5C26.5 26.6667 25.8333 27.3333 25.8333 28.3333V38.3333H17.5C16.5 38.3333 15.8333 39 15.8333 40V46.6667H7.50001C6.50001 46.6667 5.83334 47.3333 5.83334 48.3333V61.6667C5.83334 62.6667 6.50001 63.3333 7.50001 63.3333H17.5H27.5ZM29.1667 30H35.8333V60H29.1667V40V30ZM19.1667 41.6667H25.8333V60H19.1667V48.3333V41.6667ZM9.16668 50H15.8333V60H9.16668V50Z",
    fill: "#29ABE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1667 40V11.6667C84.1667 10.6667 83.5 10 82.5 10H47.5C46.5 10 45.8333 10.6667 45.8333 11.6667V40C45.8333 41 46.5 41.6667 47.5 41.6667H82.5C83.5 41.6667 84.1667 41 84.1667 40ZM80.8333 20H60.8333V13.3333H80.8333V20ZM57.5 13.3333V20H49.1667C49.1667 17.3333 49.1667 13.3333 49.1667 13.3333H57.5ZM49.1667 23.3333H57.5V38.3333H49.1667C49.1667 38.3333 49.1667 30.5 49.1667 23.3333ZM60.8333 38.3333V23.3333H80.8333V38.3333H60.8333Z",
    fill: "#F7931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 46.6667H47.5V50H82.5V46.6667Z",
    fill: "#29ABE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 55H47.5V58.3333H82.5V55Z",
    fill: "#29ABE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 63.3333H47.5V66.6667H82.5V63.3333Z",
    fill: "#29ABE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 10H24.1667V13.3333H34.1667V10Z",
    fill: "#29ABE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1667 18.3333H24.1667V21.6667H39.1667V18.3333Z",
    fill: "#29ABE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8334 71.6667H24.1667V75H35.8334V71.6667Z",
    fill: "#29ABE2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 71.6667H40.8333V75H52.5V71.6667Z",
    fill: "#29ABE2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1667 71.6667H57.5V75H69.1667V71.6667Z",
    fill: "#29ABE2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8334 80H24.1667V83.3333H35.8334V80Z",
    fill: "#29ABE2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 80H40.8333V83.3333H52.5V80Z",
    fill: "#29ABE2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1667 80H57.5V83.3333H69.1667V80Z",
    fill: "#29ABE2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8334 88.3333H24.1667V91.6667H35.8334V88.3333Z",
    fill: "#29ABE2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 88.3333H40.8333V91.6667H52.5V88.3333Z",
    fill: "#29ABE2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1667 88.3333H57.5V91.6667H69.1667V88.3333Z",
    fill: "#29ABE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.93e8b6bb8c2a7bc4a3c974bf5177e107.svg";
export { ForwardRef as ReactComponent };